import React from "react"
import { graphql, useStaticQuery } from "gatsby"

import TitleDivider from "../shared/title-divider"
import DataModelCard from "./data-model.card"
import { ContentWrapper } from "./data-model.style"

const DataModel = () => {
  const {
    buildingSrc,
    levelSrc,
    unitSrc,
    fixtureSrc,
    relationshipSrc,
    poiSrc,
    pathingSrc,
  } = useStaticQuery(graphql`
    query {
      buildingSrc: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/Exports/Desktop/Export Type Images (no shadow)/building.svg"
        }
      ) {
        publicURL
      }
      levelSrc: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/Exports/Desktop/Export Type Images (no shadow)/level.svg"
        }
      ) {
        publicURL
      }
      unitSrc: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/Exports/Desktop/Export Type Images (no shadow)/unit.svg"
        }
      ) {
        publicURL
      }
      fixtureSrc: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/Exports/Desktop/Export Type Images (no shadow)/fixture.svg"
        }
      ) {
        publicURL
      }
      relationshipSrc: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/Exports/Desktop/Export Type Images (no shadow)/relationship.svg"
        }
      ) {
        publicURL
      }
      poiSrc: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/Exports/Desktop/Export Type Images (no shadow)/points_of_interest.svg"
        }
      ) {
        publicURL
      }
      pathingSrc: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/Exports/Desktop/Export Type Images (no shadow)/pathing.svg"
        }
      ) {
        publicURL
      }
    }
  `)
  return (
    <>
      <TitleDivider text={"Data Model for Map Exports"} />
      <ContentWrapper>
        <DataModelCard
          image={buildingSrc.publicURL}
          dataType="Geometry"
          title="Building"
          body="A building is a collection of levels assembled into a structure, such as an office tower or a theatre. A building’s geometry is determined by the union of all geometry levels within the physical building."
          properties={["ID", "Venue", "Name"]}
        />
        <DataModelCard
          image={levelSrc.publicURL}
          dataType="Geometry"
          title="Level"
          body="A level represents the extent of the floor within a venue. Its boundaries are restricted by the defined building geometry."
          properties={["ID", "Building", "Abbreviation", "Elevation", "Name"]}
        />
        <DataModelCard
          image={unitSrc.publicURL}
          dataType="Geometry"
          title="Space"
          body="A space represents a defined area. That defined area is associated with a level and may be public or restricted."
          properties={[
            "ID",
            "Parent",
            "ExternalId",
            "Level",
            "Layer",
            "Color",
            "Height",
            "Altitude",
          ]}
        />
        <DataModelCard
          image={fixtureSrc.publicURL}
          dataType="Geometry"
          title="Obstruction"
          body="An obstruction is an object that acts as an obstruction to movement. It is not a structural asset and instead serves as a decorative or business function."
          properties={[
            "ID",
            "Level",
            "Parent",
            "ExternalId",
            "Layer",
            "Color",
            "Height",
            "Altitude",
          ]}
        />
        <DataModelCard
          image={relationshipSrc.publicURL}
          dataType="Geometry"
          title="Connection"
          body="A connection object is a mechanism that facilitates traversal between spaces, such as a staircase or an elevator within a building. It associates two or more levels and defines how to move between them."
          properties={[
            "ID",
            "Level",
            "Destinations",
            "Type",
            "Name",
            "Weight",
            "Multiplier",
            "Accessible",
          ]}
        />
        <DataModelCard
          image={poiSrc.publicURL}
          dataType="Data Points"
          title="Location"
          body="Locations are exported to represent all occupants in the building. This captures the geometry and associated metadata with all important services, retailers, and amenities."
          properties={[
            "ID",
            "Spaces",
            "Type",
            "Categories",
            "Name",
            "ExternalId",
            "States",
            "logo",
            "Picture",
            "Address",
            "Phone",
            "Email",
            "Social",
            "hours",
          ]}
        />
        <DataModelCard
          image={pathingSrc.publicURL}
          dataType="Data Points"
          title="Node"
          body="A node is a point on a map that is used to path end-users from their starting location to their final destination."
          properties={[
            "ID",
            "Entrance",
            "Level",
            "Neighbors",
            "Weight",
            "Multiplier",
            "Accessible",
            "ExternalId",
          ]}
        />
      </ContentWrapper>
    </>
  )
}

export default DataModel
